import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export default function TakeNoActionTable(props) {
  const getResult = (result) => {
    switch (result) {
      default:
        return result;
    }
  };

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>APPLICANT</TableCell>
          <TableCell>PERMIT</TableCell>
          <TableCell>REASON</TableCell>
          <TableCell>RECOMMENDATION</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.permits.length === 0 ? (
          <Typography variant='h6'>None</Typography>
        ) : (
          props.permits.map((permit, i) => (
            <TableRow key={i}>
              <TableCell>{permit.PERMITTEE}</TableCell>
              <TableCell>{permit.CASE_NUMBER}</TableCell>
              <TableCell>{getResult(permit.RESULT)}</TableCell>
              <TableCell>{permit.RECOMMENDATION}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
